import e from"./DescopeWc.js";customElements.get("descope-wc")?console.log("descope-wc is already defined"):customElements.define("descope-wc",e);export{e as default};
//# sourceMappingURL=index.js.map
